import { BORDER_STYLE_NONE } from 'global/constants';
import { COLOUR_GREY } from 'approot/shared/colour/colour.constants';
import type { InteractiveColumnsFragment } from '../../../lesson-builder.graphql.generated';
import { ComponentColumns } from '../../component.constants';
import type { Pluck } from 'lib/gql/pluck';

export type ColumnProperties = Pluck<
  InteractiveColumnsFragment,
  'columnProperties'
>;
export type ColumnStyle = Pluck<
  InteractiveColumnsFragment,
  'columnProperties.style'
>;

export type SettingProps = Omit<ComponentColumns, '__typename'>;

export const LAYOUT_NO_STYLE: ColumnStyle = {
  border: BORDER_STYLE_NONE,
  backgroundColour: false,
  baseColour: COLOUR_GREY.base,
  __typename: 'ComponentStyle',
};
